// Theme: molten-pixel
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'molten-pixel',
  name: 'MOLTEN PIXEL',
  tagline: 'MOLTEN PIXEL',
  description: 'Lava vermelha pixelada com textura retro 8-bit.',
  category: 'neon-cyber',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#1A0808', '#2A1010', '#EF4444', '#FEE2E2'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '2px',
      '--radius': '2px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.28)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-molten-pixel'
  },
  colorVars: {
    '--accent': '#EF4444',
    '--accent-foreground': '#1A0808',
    '--background': '#1A0808',
    '--border': '#8A2A10',
    '--card': '#2A1010',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FEE2E2',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A0808',
    '--foreground': '#FEE2E2',
    '--hold-fill': '#EF4444',
    '--input': '#8A2A10',
    '--modal-bg': '#1A0808',
    '--modal-border': '#8A2A10',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.28)',
    '--muted': '#8A2A10',
    '--muted-foreground': '#FEE2E2',
    '--nav-active': '#EF4444',
    '--nav-bg': '#2A1010',
    '--popover': '#2A1010',
    '--popover-foreground': '#FEE2E2',
    '--primary': '#EF4444',
    '--primary-foreground': '#1A0808',
    '--ring': '#EF4444',
    '--secondary': '#8A2A10',
    '--secondary-foreground': '#FEE2E2',
    '--streak': '#EF4444',
    '--success': '#22c55e',
    '--success-foreground': '#1A0808',
    '--xp': '#EF4444',
    '--xp-bg': '#2A1010'
  },
  resolvedVars: {
    '--accent': '#EF4444',
    '--accent-foreground': '#1A0808',
    '--accent-foreground-hsl': '0 53% 7%',
    '--accent-foreground-oklch': 'from #1A0808 l c h',
    '--accent-hsl': '0 84% 60%',
    '--accent-oklch': 'from #EF4444 l c h',
    '--background': '#1A0808',
    '--background-hsl': '0 53% 7%',
    '--background-oklch': 'from #1A0808 l c h',
    '--border': '#8A2A10',
    '--border-hsl': '13 79% 30%',
    '--border-oklch': 'from #8A2A10 l c h',
    '--border-w': '2px',
    '--card': '#2A1010',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FEE2E2',
    '--card-foreground-hsl': '0 93% 94%',
    '--card-foreground-oklch': 'from #FEE2E2 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--card-hsl': '0 45% 11%',
    '--card-oklch': 'from #2A1010 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A0808',
    '--destructive-foreground-hsl': '0 53% 7%',
    '--destructive-foreground-oklch': 'from #1A0808 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FEE2E2',
    '--foreground-hsl': '0 93% 94%',
    '--foreground-oklch': 'from #FEE2E2 l c h',
    '--hold-fill': '#EF4444',
    '--hold-fill-hsl': '0 84% 60%',
    '--hold-fill-oklch': 'from #EF4444 l c h',
    '--input': '#8A2A10',
    '--input-hsl': '13 79% 30%',
    '--input-oklch': 'from #8A2A10 l c h',
    '--modal-bg': '#1A0808',
    '--modal-bg-hsl': '0 53% 7%',
    '--modal-bg-oklch': 'from #1A0808 l c h',
    '--modal-border': '#8A2A10',
    '--modal-border-hsl': '13 79% 30%',
    '--modal-border-oklch': 'from #8A2A10 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.28)',
    '--muted': '#8A2A10',
    '--muted-foreground': '#FEE2E2',
    '--muted-foreground-hsl': '0 93% 94%',
    '--muted-foreground-oklch': 'from #FEE2E2 l c h',
    '--muted-hsl': '13 79% 30%',
    '--muted-oklch': 'from #8A2A10 l c h',
    '--nav-active': '#EF4444',
    '--nav-active-hsl': '0 84% 60%',
    '--nav-active-oklch': 'from #EF4444 l c h',
    '--nav-bg': '#2A1010',
    '--nav-bg-hsl': '0 45% 11%',
    '--nav-bg-oklch': 'from #2A1010 l c h',
    '--popover': '#2A1010',
    '--popover-foreground': '#FEE2E2',
    '--popover-foreground-hsl': '0 93% 94%',
    '--popover-foreground-oklch': 'from #FEE2E2 l c h',
    '--popover-hsl': '0 45% 11%',
    '--popover-oklch': 'from #2A1010 l c h',
    '--primary': '#EF4444',
    '--primary-foreground': '#1A0808',
    '--primary-foreground-hsl': '0 53% 7%',
    '--primary-foreground-oklch': 'from #1A0808 l c h',
    '--primary-hsl': '0 84% 60%',
    '--primary-oklch': 'from #EF4444 l c h',
    '--radius': '2px',
    '--ring': '#EF4444',
    '--ring-hsl': '0 84% 60%',
    '--ring-oklch': 'from #EF4444 l c h',
    '--secondary': '#8A2A10',
    '--secondary-foreground': '#FEE2E2',
    '--secondary-foreground-hsl': '0 93% 94%',
    '--secondary-foreground-oklch': 'from #FEE2E2 l c h',
    '--secondary-hsl': '13 79% 30%',
    '--secondary-oklch': 'from #8A2A10 l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.28)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#EF4444',
    '--streak-hsl': '0 84% 60%',
    '--streak-oklch': 'from #EF4444 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#1A0808',
    '--success-foreground-hsl': '0 53% 7%',
    '--success-foreground-oklch': 'from #1A0808 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(0 84% 60% / 0.15)',
    '--xp': '#EF4444',
    '--xp-bg': '#2A1010',
    '--xp-bg-hsl': '0 45% 11%',
    '--xp-bg-oklch': 'from #2A1010 l c h',
    '--xp-hsl': '0 84% 60%',
    '--xp-oklch': 'from #EF4444 l c h'
  }
}
